import ParameterErrors from '../../../errors/ParameterErrors';
const { throwNotProvided } = ParameterErrors;
const OBJECT_IDS_JSON_KEY='o';
export default class Quadrant {
	constructor({objectIds }){
		this._objectIds = objectIds; 
	}
	get objectIds(){
		return this._objectIds;
	}
	static fromJSON(jObject){
		const objectIds = jObject[OBJECT_IDS_JSON_KEY];
		return new Quadrant({objectIds});
	}
}